/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GeneralResponse } from '../../models/general-response';
import { InputUpdateClientDto } from '../../models/input-update-client-dto';

export interface ClientManagementEditClientPost$Plain$Params {
      body?: InputUpdateClientDto
}

export function clientManagementEditClientPost$Plain(http: HttpClient, rootUrl: string, params?: ClientManagementEditClientPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneralResponse>> {
  const rb = new RequestBuilder(rootUrl, clientManagementEditClientPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GeneralResponse>;
    })
  );
}

clientManagementEditClientPost$Plain.PATH = '/ClientManagement/EditClient';
